<template>
  <div>
    <v-layout row wrap>
      <v-flex sm6 md4>
        <v-select
          :items="tiposDoc"
          v-model="tipo_documento"
          label="Tipo de documento"
          item-text="text"
          item-value="value"
          :rules="$validate(['required'])"
          required
          class="required"
          :disabled="!!persona"
          ></v-select>
      </v-flex>
      <v-flex sm6 md4>
        <v-text-field
          label="Número de documento"
          v-model="nro_documento"
          maxlength="20"
          @keydown.native="$filter.numeric($event)"
          :rules="$validate(['required'])"
          required
          class="required"
          :disabled="!!persona"
          ></v-text-field>
      </v-flex>
      <v-flex :class="change ? 'sm8 md4' : 'md4'">
        <select-date
          label="Fecha de nacimiento"
          model="form.fecha_nacimiento"
          :store="store"
          :required="true"
          class="required"
          :disabled="!!persona"
          :max-year="parseInt(this.$datetime.now(false, 'YYYY'))"
          :value="$store.state.date['form.fecha_nacimiento']"
        >
        </select-date>
      </v-flex>

      <v-flex md4>
        <v-text-field
          label="Nombre(s)"
          v-model="nombres"
          maxlength="100"
          :rules="$validate(['required'])"
          class="required"
          required
          :disabled="!!persona || (persona && !!persona.nombres)"
          ></v-text-field>
      </v-flex>

      <v-flex md4>
        <v-text-field
          label="Primer apellido"
          v-model="primer_apellido"
          :rules="$validate(['required'])"
          maxlength="100"
          required
          :disabled="!!persona || (persona && !!persona.paterno)"
          ></v-text-field>
      </v-flex>

      <v-flex md4>
        <v-text-field
          label="Segundo apellido"
          v-model="segundo_apellido"
          maxlength="100"
          :disabled="!!persona || (persona && !!persona.materno)"
          ></v-text-field>
      </v-flex>

      <v-flex md4>
        <v-autocomplete
          :items="nacionalidades"
          v-model="nacionalidad"
          label="Nacionalidad"
          item-text="text"
          item-value="value"
          :rules="$validate(['required'])"
          :disabled="!!persona"
          required
          class="required"
          ></v-autocomplete>
      </v-flex>

      <v-flex md4>
        <v-radio-group
          v-model="genero"
          row
          :rules="$validate(['required'])"
          :disabled="!!persona"
          required
          class="required"
        >
          <v-radio
            label="Mujer"
            value="F"
          ></v-radio>
          <v-radio
            label="Hombre"
            value="M"
          ></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex sm4 md2 v-if="change">
        <v-btn
          v-if="persona"
          @click="cambiar"><v-icon>compare_arrows</v-icon> Cambiar</v-btn>
        <v-btn
          color="info"
          v-if="!persona"
          :loading="loading"
          :disabled="$filter.empty(tipo_documento) || $filter.empty(nro_documento) || $filter.empty(fecha_nacimiento) || $filter.empty(nombres) || $filter.empty(primer_apellido) || loading"
          @click="buscarPersona"><v-icon>search</v-icon> Buscar</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SelectDate from '@/common/util/SelectDate';
import validate from '@/common/mixins/validate';
import { mapFields } from 'vuex-map-fields';
import paises from '@/common/mixins/paises';
import moment from 'moment';

export default {
  mixins: [ validate, paises ],
  props: {
    store: {
      type: String,
      default: ''
    },
    change: {
      type: Boolean,
      default: true
    },
    db: {
      type: Boolean,
      default: false
    }
  },
  created () {
    let items = this.getPaises();
    let paises = [];
    let nacionalidades = [];
    items.map(item => {
      paises.push({ value: item.pais, text: item.pais });
      nacionalidades.push({ value: item.nacionalidad, text: item.nacionalidad });
    });
    this.paises = paises;
    this.nacionalidades = nacionalidades;
  },
  data () {
    return {
      tiposDoc: [
        { value: 'CI', text: 'CÉDULA DE IDENTIDAD' },
        { value: 'PASAPORTE', text: 'PASAPORTE' }
      ],
      loading: false,
      contrastado: false
    };
  },
  beforeCreate () {
    // Creando campos del formulario en el store definido en props
    let store = this.$options.propsData.store || '';
    this.$options.computed = {
      ...mapFields([
        'form.tipo_documento',
        'form.tipo_documento_otro',
        'form.nro_documento',
        'form.persona',
        'form.fecha_nacimiento',
        'form.nombres',
        'form.primer_apellido',
        'form.segundo_apellido',
        'form.nacionalidad',
        'form.genero'
      ], `${store}getField`, `${store}updateField`)
    };
  },
  methods: {
    formato (valor) {
      if (valor) {
        moment.locale('es');
        let date = moment(valor).format('L');
        return date;
      } else {
        return '';
      }
    },
    buscarPersona () {
      this.$loading.show('Buscando persona...');
      this.loading = true;
      let datosPersona = {
        nro_documento: this.nro_documento,
        fecha_nacimiento: this.formato(this.fecha_nacimiento),
        primer_apellido: this.primer_apellido.toUpperCase(),
        nombres: this.nombres.toUpperCase(),
        genero: this.genero
      };
      if (this.segundo_apellido && this.segundo_apellido.length > 0) {
        datosPersona.segundo_apellido = this.segundo_apellido.toUpperCase();
      } else {
        datosPersona.segundo_apellido = '--';
      }
      let url = `system/personas/contrastar`;
      this.$service.patch(url, datosPersona)
      .then(response => {
        this.loading = false;
        if (response) {
          if (response.estado === 'VERIFICADO_SEGIP' && response.data === '') {
            this.nacionalidad = 'BOLIVIANA';
            this.nombres = datosPersona.nombres.toUpperCase();
            this.primer_apellido = datosPersona.primer_apellido.toUpperCase();
            if (datosPersona.segundo_apellido === '--') {
              this.segundo_apellido = '';
            } else {
              this.segundo_apellido = datosPersona.segundo_apellido.toUpperCase();
            }
            this.genero = datosPersona.genero;
            this.contrastado = true;
            this.$message.success(`Los datos son válidos.`, null, { timeout: 7000 });
            this.$store.commit(`${this.store}setForm`, {
              persona: datosPersona
            });
          } else if (this.tipo_documento !== 'CI') {
            this.$message.warning(`No se encontraron los datos <br /> <strong>Revise los datos antes de guardar</strong>`, null, { timeout: 12000 });
            this.contrastado = true;
            this.nombres = datosPersona.nombres.toUpperCase();
            this.primer_apellido = datosPersona.primer_apellido.toUpperCase();
            if (datosPersona.segundo_apellido === '--') {
              this.segundo_apellido = '';
            } else {
              this.segundo_apellido = datosPersona.segundo_apellido.toUpperCase();
            }
            this.$store.commit(`${this.store}setForm`, {
              persona: datosPersona
            });
          } else {
            this.$message.warning(`Los datos parecen incorrectos, revíselos.<br /> <strong>`, response, `</strong>`, null, { timeout: 12000 });
          }
        } else {
          this.$message.error(`Ocurrió un problema. No se encontraron los datos <br /> <strong>Comuníquese con su administrador.</strong>`, null, { timeout: 10000 });
        }
      });
    },
    cambiar () {
      this.$store.commit(`${this.store}setForm`, {
        primer_apellido: '',
        segundo_apellido: '',
        nombres: '',
        nacionalidad: '',
        tipo_documento: '',
        nro_documento: '',
        fecha_nacimiento: '',
        telefono: '',
        movil: '',
        genero: '',
        persona: null
      });
      this.contrastado = false;
      this.$store.commit('cleanDate', 'form.fecha_nacimiento');
    }
  },
  components: {
    SelectDate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/persona/PersonaSegipContraste.vue